import SrUpload from "./SrUpload.vue";

SrUpload.install = function(Vue) {
  Vue.component(SrUpload.name, SrUpload);
};

export default SrUpload;


// WEBPACK FOOTER //
// ./packages/SrUpload/index.js